export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const CLEAR_CART = 'CLEAR_CART'
export const FETCH_LOCAL_STORAGE = 'FETCH_LOCAL_STORAGE'
export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY'
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM'
export const SET_CURRENT_FILTERTAG = 'SET_CURRENT_FILTERTAG'
export const SET_CART_AMOUNT = 'SET_CART_AMOUNT'
export const SET_STRIPE_TOKEN = 'SET_STRIPE_TOKEN'
export const SET_TABLE_NUMBER = 'SET_TABLE_NUMBER'
export const SET_STRIPE_CONNECT_USER_ID = 'SET_STRIPE_CONNECT_USER_ID'
// export const SET_PRINTER_LANGUAGE = 'SET_PRINTER_LANGUAGE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js